module.exports = require("lodash/every");